import React from "react";

function ExternalLinkData({ value, href }) {
  return (
    <a target="_blank" rel="noreferrer" href={href}>
      {value}
    </a>
  );
}

export default ExternalLinkData;
